import { useEffect, useState } from "react";
import { FlaskConical, ChevronDown } from "lucide-react";
import { api } from "../../lib/api";
import { SimConsole } from "./SimConsole";

// Only shown to a logged-in operator so they can test without the NFC reader or the button boxes.
export const SimToolbar = ({ onScan, consoleMap }) => {
  const [tags, setTags] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    api.get("/admin/specimens").then((r) => setTags(r.data)).catch(() => setTags(null));
  }, []);

  if (!tags) return null;
  return (
    <div data-testid="sim-toolbar" className="fixed bottom-0 left-0 right-0 z-[45] border-t border-amber-400/30 bg-[#050807]/95 backdrop-blur-xl">
      <button data-testid="sim-toolbar-toggle" onClick={() => setOpen(!open)} className="flex w-full items-center justify-between px-6 py-2 font-mono text-xs uppercase tracking-widest text-amber-300">
        <span className="flex items-center gap-2"><FlaskConical size={14} /> Operator simulation (only visible while logged in to setup)</span>
        <ChevronDown size={16} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="max-h-[45vh] overflow-y-auto px-6 pb-4">
          <div className="flex flex-wrap gap-2">
            <button data-testid="simulated-tag-button-unknown" onClick={() => onScan("UNKNOWN-TAG")} className="sim-chip border-rose-400/40 text-rose-300">Unknown tag</button>
            {tags.map((t) => (
              <button key={t.id} data-testid={`simulated-tag-button-${t.slot}`} onClick={() => onScan(t.tag_uid)} className="sim-chip">
                {String(t.slot).padStart(2, "0")} {t.name}
              </button>
            ))}
          </div>
          <SimConsole consoleMap={consoleMap} />
        </div>
      )}
    </div>
  );
};
